import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  const handleGetStarted = () => {
    window.location.href = '?page=trial-signup';
  };

  return (
    <>
      {/* Footer CTA Section */}
      <section className="py-32 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 overflow-hidden">
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-8 tracking-tight">
            {t('footer.cta.title')}
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
            {t('footer.cta.subtitle')}
          </p>
          <button
            onClick={handleGetStarted}
            className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-12 py-6 rounded-2xl text-2xl font-black hover:from-blue-600 hover:to-cyan-600 transition-all hover:scale-110 shadow-2xl"
          >
            {t('footer.cta.button')}
          </button>
        </div>
      </section>

      <footer className="bg-gray-900 text-white py-16 overflow-hidden">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold mb-4 text-cyan-400">Smart Mates for Sales</h3>
            <p className="text-gray-300 leading-relaxed">{t('footer.tagline')}</p>
          </div>

          <div className="text-right">
            <h4 className="text-lg font-bold mb-4 text-white">{t('footer.company.title')}</h4>
            <p className="text-gray-300 mb-2 font-semibold">{t('footer.company.name')}</p>
            <p className="text-gray-400 text-sm">{t('footer.company.description')}</p>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-400 text-sm">
            {t('footer.copyright')}
          </p>
          <p className="mt-2">
            <a
              href="https://smartmates.org/?page=privacy-policy"
              className="text-gray-400 hover:text-white text-sm underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.privacyPolicy')}
            </a>
          </p>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;

